import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './contexts/AuthContext';
import { AccessibilityProvider } from './contexts/AccessibilityContext';
import { AccessibilityWidget } from './components/accessibility/AccessibilityWidget';
import { ProtectedRoute } from './components/ProtectedRoute';
import LandingPage from './pages/LandingPage';
import ClientReportPage from './pages/ClientReportPage';
import LoginPage from './pages/admin/LoginPage';
import PartnersPage from './pages/admin/PartnersPage';
import NewsPage from './pages/admin/NewsPage';
import LeadsPage from './pages/admin/LeadsPage';
import CompaniesPage from './pages/admin/CompaniesPage';
import PersonnelPage from './pages/admin/PersonnelPage';
import AssessmentsPage from './pages/admin/AssessmentsPage';
import ExecutiveDashboardPage from './pages/admin/ExecutiveDashboardPage';
import './i18n';
import './App.css';

function App() {
  return (
    <Router>
      <AccessibilityProvider>
        <AuthProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/client/reports/:token" element={<ClientReportPage />} />
            <Route path="/admin/login" element={<LoginPage />} />

            {/* Protected Admin Routes */}
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute requireAdmin>
                  <ExecutiveDashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/partners"
              element={
                <ProtectedRoute requireAdmin>
                  <PartnersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/news"
              element={
                <ProtectedRoute requireAdmin>
                  <NewsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/leads"
              element={
                <ProtectedRoute requireAdmin>
                  <LeadsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/companies"
              element={
                <ProtectedRoute requireAdmin>
                  <CompaniesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/personnel"
              element={
                <ProtectedRoute requireAdmin>
                  <PersonnelPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/assessments"
              element={
                <ProtectedRoute requireAdmin>
                  <AssessmentsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/assessments/:id"
              element={
                <ProtectedRoute requireAdmin>
                  <AssessmentsPage />
                </ProtectedRoute>
              }
            />

            {/* Redirect /admin to /admin/dashboard */}
            <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />

            {/* Catch all - redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>

          <AccessibilityWidget />

          <Toaster
            position="top-right"
            aria-live="polite"
            aria-atomic="true"
          />
        </AuthProvider>
      </AccessibilityProvider>
    </Router>
  );
}

export default App;
